module.exports = __webpack_public_path__ + "static/images/share4.6862399.png";